import { JSX, useEffect, useState } from 'react';
import TitleInput from '../../common/title/title';
import { CalendarEvent, calendarService } from '../../services/calendarService';
import './eventEdit.css';
import TodoDate from '../../todolist/todoDate/date';
import lsp from '../../assets/images/gifs/LSP.gif';
import ContentBox from '../../todolist/add-todo/contentBox';
import AddButton from '../../common/AddButton/addButton';
import Loading from '../../common/Loading/loading';

const EventEdit = ({ handleAddEvent }: { handleAddEvent: () => void }): JSX.Element => {
    const [startDate, setStartDate] = useState<Date>(new Date());
    const [endDate, setEndDate] = useState<Date>(new Date());
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isAllDay, setIsAllDay] = useState<boolean>(true);

    const [newEvent, setNewEvent] = useState<CalendarEvent>({
        id: '',
        summary: '',
        description: '',
        calendarId: 'HYTE',
        start: { date: startDate.toISOString().split('T')[0]},
        end: { date: endDate.toISOString().split('T')[0] },
    });

    const changeEventSummary = (summary: string) => {
        setNewEvent({ ...newEvent, summary });
    }

    const changeEventDescription = (description: string) => {
        setNewEvent({ ...newEvent, description });
    }

    const toggleAllDay = () => {
        setIsAllDay(!isAllDay);
    }

    // const checkTime = () => {
    //     if (!isAllDay) {
    //         const startDateStr = startDate.toISOString();
    //         const endDateStr = endDate.toISOString();
    //         setNewEvent({
    //             ...newEvent,
    //             start: { dateTime: startDateStr },
    //             end: { dateTime: endDateStr }
    //         });
    //     } else {
    //         // Switching to timed event
    //         setNewEvent({
    //             ...newEvent,
    //             start: { date: startDate.toISOString().split('T')[0] },
    //             end: { date: endDate.toISOString().split('T')[0] }
    //         });
    //     }
    // }

    const addEvent = async () => {
        if (newEvent.summary !== '') {
            //checkTime();
            setIsLoading(true);
            await calendarService.createEvent(newEvent);

            setNewEvent({
                id: '',
                summary: '',
                description: '',
                start: { },
                end: { },
            });
            setIsLoading(false);
            handleAddEvent();
        }
    }

    const dateChangeHandle = (date: Date) => {
        setStartDate(date);
        setNewEvent({ ...newEvent, 
            start: { date: date.toISOString().split('T')[0] },
            end: { date: date.toISOString().split('T')[0] }
        });
    }

    return (
        <div className='event-edit-container'>
            <TitleInput title={newEvent.summary} setTitle={changeEventSummary}/>
            <div className='event-edit-content-container'>
                <div className='event-edit-time-container'>
                    <TodoDate dateFormat={'MMM dd, EEE'} date={startDate} onTodoDateChange={(date) => dateChangeHandle(date)}/>
                    <div className="divider"/>
                    <img src={lsp} alt="calendar" className="event-edit-calendar-icon"/>
                    {/* <div className="divider"/>
                    <label className="all-day-toggle">
                        <input 
                            type="checkbox" 
                            checked={isAllDay} 
                            onChange={toggleAllDay}
                        />
                        All Day
                    </label> */}
                </div>
                <div className="divider-horizontal"/>
                <ContentBox todoContent={newEvent.description} onContentChange={changeEventDescription} onFocus={() => {}}/>
            </div>
            <div className='event-edit-add-button-container'>
                <AddButton title='Add' addFunction={addEvent}/>
            </div>
            {isLoading ? <Loading/> : <></>}
        </div>
    );
}

export default EventEdit;
